import React from 'react'

function TabButton({ name, label, active }) {
  return (
    <button
      className={`nav-link ${active && 'active'}`}
      id={`nav-${name}-tab`}
      data-bs-toggle={`tab`}
      data-bs-target={`#nav-${name}`}
      type={`button`}
      role={`tab`}
      aria-controls={`nav-${name}`}
      aria-selected={true}>
      {label}
    </button>
  )
}

export default TabButton
